import { z } from 'zod';
import { time } from '../../../common/atomic/time';
import { date } from '../../../common/atomic/date';
import { pageableRequestSchema } from '../../pageable/request';

export const availabilitySchema = z.object({
  id: z.number(),
  date,
  startTime: time,
  endTime: time,
  empId: z.number(),
});

export const availabilitiesSchema = z
  .object({
    content: z.array(availabilitySchema),
  })
  .merge(pageableRequestSchema);

export type Availability = z.infer<typeof availabilitySchema>;
export type Availabilities = z.infer<typeof availabilitiesSchema>;
